import React from "react";

import QueryStatusBadge
  from "./QueryStatusBadge";

import {
  formatQueryDate,
  getQueryClientName,
  getQueryClientCompany,
  getQuerySubject,
  getQueryOffering,
  getQueryAssignedUser,
} from "../utils/query.utils";


const QueryTable = ({
  queries = [],
  loading = false,
  onView,
}) => {

  if (loading) {
    return (
      <div className="query-table-state">
        Loading queries...
      </div>
    );
  }


  if (!queries.length) {
    return (
      <div className="query-table-state">
        No queries found.
      </div>
    );
  }


  return (
    <div className="query-table-wrapper">

      <table className="query-table">

        <thead>
          <tr>

            <th>Client</th>

            <th>Subject</th>

            <th>Offering</th>

            <th>Status</th>

            <th>Assigned To</th>

            <th>Created</th>

            <th>Action</th>

          </tr>
        </thead>


        <tbody>

          {queries.map((item) => (

            <tr key={item.id}>

              <td>

                <div className="query-client">

                  <strong>
                    {getQueryClientName(
                      item
                    )}
                  </strong>

                  {item.client_company_name && (
                    <span>
                      {getQueryClientCompany(
                        item
                      )}
                    </span>
                  )}

                  {item.client_email && (
                    <small>
                      {item.client_email}
                    </small>
                  )}

                </div>

              </td>


              <td>

                <div className="query-subject">

                  {getQuerySubject(
                    item
                  )}

                </div>

              </td>


              <td>
                {getQueryOffering(
                  item
                )}
              </td>


              <td>

                <QueryStatusBadge
                  status={item.status}
                />

              </td>


              <td>
                {getQueryAssignedUser(
                  item
                )}
              </td>


              <td>
                {formatQueryDate(
                  item.created_at
                )}
              </td>


              <td>

                <button
                  type="button"
                  className="query-view-button"
                  onClick={() =>
                    onView?.(item)
                  }
                >
                  View
                </button>

              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>
  );
};


export default QueryTable;